import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8892ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "產生寵物身份證中...", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { slot: "end" }
const _hoisted_7 = { class: "datetime-modal-content" }
const _hoisted_8 = { style: {"margin-top":"50px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_poster_lost_pet = _resolveComponent("poster-lost-pet")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isEditing ? (_ctx.userPet.name || _ctx.t('Pet.userPet')) : _ctx.t('Pet.newUserPet')), 1)
              ]),
              _: 1
            }),
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock(_component_ion_buttons, {
                  key: 0,
                  slot: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPopoverOpen(true, $event)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          ios: _ctx.ellipsisHorizontal,
                          md: _ctx.ellipsisVertical
                        }, null, 8, ["ios", "md"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_popover, {
                      "is-open": _ctx.isPopoverOpenRef,
                      event: _ctx.popoverEvent,
                      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPopoverOpen(false))),
                      "dismiss-on-select": true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteUserPet())),
                                  lines: "none",
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      color: "danger",
                                      slot: "start",
                                      icon: _ctx.trashOutline
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_ion_label, { color: "danger" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("刪除寵物")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["is-open", "event"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.isEditing)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment, {
                  mode: "md",
                  modelValue: _ctx.selectedCanvasType,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCanvasType) = $event)),
                  scrollable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, { value: "寵物身份證" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("寵物身份證")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, { value: "尋寵啟事" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("尋寵啟事")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            (_ctx.isEditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _withDirectives(_createVNode(_component_poster_lost_pet, {
                    ref: "posterLostPet",
                    pet: { ..._ctx.editingUserPet, ..._ctx.userPet }
                  }, null, 8, ["pet"]), [
                    [_vShow, _ctx.selectedCanvasType == '尋寵啟事']
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              (_ctx.canvas.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_ion_spinner),
                    _hoisted_3
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_ion_toolbar, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_ion_buttons, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              color: "secondary",
                              shape: "round",
                              fill: "outline",
                              onClick: _ctx.sharePetIdImg
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.shareSocialOutline
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.t('share')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_ion_button, {
                              fill: "outline",
                              color: "secondary",
                              shape: "round",
                              onClick: _ctx.savePetIdCardImage
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.downloadOutline
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.t('save')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.isEditing]
                        ]),
                        _createVNode(_component_ion_buttons, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openImageModal(_ctx.getCanvasDataURL())))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "icon-only",
                                  icon: _ctx.expand
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_stage, {
                      ref: "stageRef",
                      config: { width: _ctx.sceneWidth, height: _ctx.sceneHeight }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_layer, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_image, {
                              config: {
                id: 'card',
                width: _ctx.sceneWidth,
                height: _ctx.sceneHeight,
                x: 0,
                y: 0,
                image: _ctx.canvas.idCardImg,
                preventDefault: false,
              }
                            }, null, 8, ["config"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_layer, null, {
                          default: _withCtx(() => [
                            (_ctx.canvas.loadingPetImg)
                              ? (_openBlock(), _createBlock(_component_v_image, {
                                  key: 0,
                                  config: {
                id: 'mlpSpinner',
                width: 50,
                height: 55,
                x: 50,
                y: _ctx.sceneHeight / 2 + 20,
                image: _ctx.canvas.logoImg,
                offset: {
                  x: 25,
                  y: 27.5,
                },
              }
                                }, null, 8, ["config"]))
                              : _createCommentVNode("", true),
                            (!_ctx.canvas.loadingPetImg && _ctx.canvas.petImg)
                              ? (_openBlock(), _createBlock(_component_v_image, {
                                  key: 1,
                                  config: {
                scaleX: Math.min(_ctx.canvas.petImgWidth / _ctx.canvas.petImg.naturalWidth, _ctx.canvas.petImgHeight / _ctx.canvas.petImg.naturalHeight),
                scaleY: Math.min(_ctx.canvas.petImgWidth / _ctx.canvas.petImg.naturalWidth, _ctx.canvas.petImgHeight / _ctx.canvas.petImg.naturalHeight),
                x: 20,
                y: _ctx.sceneHeight / 2 - 10,
                image: _ctx.canvas.petImg
              }
                                }, null, 8, ["config"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_text, {
                              config: {
                  x: 25,
                  y: _ctx.sceneHeight / 2 - 40,
                  width: _ctx.sceneWidth - 25,
                  height: 10,
                  text: _ctx.userPet.name,
                  fontSize: 12,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: 25,
                  y: _ctx.sceneHeight / 2 - 25,
                  width: _ctx.sceneWidth - 25,
                  height: 10,
                  text: _ctx.userPet.nameEn,
                  fontSize: 12,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: _ctx.sceneWidth / 2 - 28,
                  y: _ctx.sceneHeight / 2 - 10,
                  width: _ctx.sceneWidth / 2,
                  height: 10,
                  text: _ctx.getChineseComCode(_ctx.userPet.name),
                  fontSize: 12,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: _ctx.sceneWidth / 2 - 28,
                  y: _ctx.sceneHeight / 2 + 20,
                  width: 100,
                  height: 10,
                  text: _ctx.formatDateString(_ctx.userPet.dateOfBirth, 'DD-MM-YYYY'),
                  fontSize: 12,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: _ctx.sceneWidth / 2 + 40,
                  y: _ctx.sceneHeight / 2 + 20,
                  width: 30,
                  height: 10,
                  text: _ctx.userPet.gender ? (_ctx.userPet.gender == 'male' ? '男 M' : '女 F') : '',
                  fontSize: 9,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: _ctx.sceneWidth / 2 - 28,
                  y: _ctx.sceneHeight / 2 + 50,
                  width: 100,
                  height: 10,
                  text: _ctx.formatDateString(_ctx.userPet.createdAt, '(MM-YY)'),
                  fontSize: 12,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: _ctx.sceneWidth / 2 - 28,
                  y: _ctx.sceneHeight - 20,
                  width: 100,
                  height: 10,
                  text: _ctx.formatDateString(_ctx.userPet.createdAt, 'DD-MM-YY'),
                  fontSize: 13,
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_image, {
                              config: {
                width: 50,
                height: 55,
                x: _ctx.sceneWidth - 70,
                y: _ctx.sceneHeight - 80,
                image: _ctx.canvas.logoImg
              }
                            }, null, 8, ["config"]),
                            _createVNode(_component_v_text, {
                              config: {
                  x: _ctx.sceneWidth - 85,
                  y: _ctx.sceneHeight - 20,
                  width: 80,
                  height: 10,
                  text: _ctx.userPet.cardIdNumber,
                  fontSize: 13,
                  align: 'center',
                  verticalAlign: 'middle',
                  fontFamily: 'Calibri',
                }
                            }, null, 8, ["config"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["config"])
                  ])),
              _createElementVNode("form", {
                onSubmit: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.upsertUserPet()), ["prevent"]))
              }, [
                _createVNode(_component_ion_list, { style: {"padding-top":"0"} }, {
                  default: _withCtx(() => [
                    (_ctx.photos.length == 0)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 0,
                          class: "no-inner-border",
                          fill: "outline",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.takePhoto())),
                          button: "",
                          detail: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pet.petPhoto')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_buttons, { slot: "end" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.camera
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_item, {
                          key: 1,
                          class: "no-inner-border",
                          fill: "outline",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openImageCropperModal())),
                          button: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('Pet.petPhoto')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_thumbnail, null, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  style: {"object-fit":"contain"},
                                  src: _ctx.photos[0].base64Data
                                }, null, 8, _hoisted_5)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_buttons, { slot: "end" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.openImageCropperModal()), ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.crop
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  color: "danger",
                                  onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.setPhotos([])), ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "icon-only",
                                      icon: _ctx.close
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _withDirectives(_createVNode(_component_ion_item, {
                      class: "no-inner-border",
                      fill: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.removeBgOrNot')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_toggle, {
                          id: "rembg-toggle",
                          slot: "end",
                          onIonChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setUseRemovedBgPhoto($event.detail.checked))),
                          checked: _ctx.userPet.useRembgPhoto == true || _ctx.userPet.useRembgPhoto == 'Y'
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.photos.length > 0]
                    ]),
                    _createVNode(_component_ion_item, { fill: "outline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.petType')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          modelValue: _ctx.targetPetCategory,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.targetPetCategory) = $event)),
                          interface: "popover"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.petCategories, (category) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: category,
                                value: category
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(category), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      fill: "outline",
                      onClick: _ctx.openBreedSelectModal,
                      button: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.breed')) + "*", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.userPet.breed,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userPet.breed) = $event)),
                          clearInput: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ion_item, { fill: "outline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.name')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.userPet.name,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userPet.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { fill: "outline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.nameEn')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.userPet.nameEn,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userPet.nameEn) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { fill: "outline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.color')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.userPet.color,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userPet.color) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      class: "no-inner-border",
                      fill: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.gender')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_ion_chip, {
                            outline: _ctx.userPet.gender != 'male',
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.userPet.gender = 'male'))
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.checkmark }, null, 8, ["icon"]), [
                                [_vShow, _ctx.userPet.gender == 'male']
                              ]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('Pet.male')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["outline"]),
                          _createVNode(_component_ion_chip, {
                            outline: _ctx.userPet.gender != 'female',
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.userPet.gender = 'female'))
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_icon, { icon: _ctx.checkmark }, null, 8, ["icon"]), [
                                [_vShow, _ctx.userPet.gender == 'female']
                              ]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('Pet.female')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["outline"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      class: "no-inner-border",
                      fill: "outline",
                      id: "open-date-input",
                      button: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.dateOfBirth')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_text, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userPet.dateOfBirth), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_modal, {
                      ref: "dateInputModal",
                      trigger: "open-date-input",
                      "show-backdrop": true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_toolbar, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_buttons, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      slot: "icon-only",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dateInputModal.$el.dismiss()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_ion_datetime, {
                                mode: "ios",
                                modelValue: _ctx.userPet.dateOfBirth,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userPet.dateOfBirth) = $event)),
                                presentation: "date",
                                preferWheel: true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                style: {"max-width":"480px","margin":"0 auto"},
                                onClick: _ctx.saveDateOfBirth
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('confirm')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512),
                    _createVNode(_component_ion_item, { fill: "outline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.origin')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.userPet.origin,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userPet.origin) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { fill: "outline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.notes')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_textarea, {
                          modelValue: _ctx.userPet.notes,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userPet.notes) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      style: {"margin":"0"},
                      lines: "full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Pet.isNeutered')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_checkbox, {
                          slot: "end",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.userPet.isNeutered = $event)),
                          modelValue: _ctx.userPet.isNeutered
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.settings.allowSetShowOnBanners == 'Y')
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 2,
                          style: {"margin":"0"},
                          lines: "full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.locale == 'zh' ? _ctx.settings.showOnBannersText : _ctx.settings.showOnBannersTextEn), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_checkbox, {
                              slot: "end",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.userPet.showOnBanners = $event)),
                              modelValue: _ctx.userPet.showOnBanners
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_toolbar, { class: "ion-text-center fixed-bottom" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        type: "submit",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('save')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ], 32)
            ], 512), [
              [_vShow, _ctx.selectedCanvasType == '寵物身份證']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}